import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserCoinsProvider } from './userCoinContext';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import OtbcApi from './api';


OtbcApi.setupInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <UserCoinsProvider>
    <App />
    </UserCoinsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
